/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
    scriptProps={{
      async: true,
      defer: true,
    }}
  >
    {element}
  </GoogleReCaptchaProvider>
)
